import { StyleSheet, View } from "react-native";

import { radii, useThemedStyles, type ThemeColors } from "~/styles/theme";

export function CheckboxMark({ checked }: { checked: boolean }) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View
      accessibilityElementsHidden
      importantForAccessibility="no"
      style={[stylesheet.checkbox, checked ? stylesheet.checked : null]}
    />
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    checkbox: {
      width: 16,
      height: 16,
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: radii.xs,
    },
    checked: {
      borderColor: colors.primary,
      backgroundColor: colors.primary,
    },
  });
